module.exports = __webpack_public_path__ + "img/logo.f287f8ce.png";